import React, { Component } from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'
import * as R from 'ramda'
import Modal from '../../UniformComponents/Modal'
import Button from '../../UniformComponents/Button'
import ModalFooter from '../../UniformComponents/ModalFooter'
import ModalHeader from '../../UniformComponents/ModalHeader'
import Select from '../form/Select'
import Input from '../form/Input'

@observer
class AddPinnedCustomTagFilterModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            customTag: undefined,
            filterLabel: undefined,
            filterType: 'single',
        }
    }

    save = async () => {
        const { dashStore } = this.props
        const { addPinnedCustomtagFilter, toggleShowAddPinnedCustomTagFilters } = dashStore
        const {
            customTag,
            filterLabel,
            filterType,
        } = this.state

        addPinnedCustomtagFilter({
            customTag,
            filterLabel,
            filterType,
        })
        toggleShowAddPinnedCustomTagFilters()
    }

    renderControls = () => {
        const { dashStore } = this.props
        const { benchmarkTags } = dashStore

        const filterTypes = [
            { value: 'single', label: 'Single Select' },
            { value: 'multi', label: 'Multi Select' },
        ]

        const groupOpts = benchmarkTags.map(({
            customTagName, customTagConfig, customTagId, parentConfig, tagOptions,
        }) => {
            const config = parentConfig || customTagConfig
            if (!JSON.parse(config).benchmarkOptions.includes('publish')) return undefined
            return { value: customTagId, label: customTagName }
        }).filter((b) => b !== undefined)

        const {
            customTag,
            filterLabel,
            filterType,
        } = this.state

        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                <Select
                    label={i18n.t('dynamicDash.group')}
                    name="question"
                    options={groupOpts}
                    value={groupOpts.find((q) => (q.value === customTag))}
                    onBlur={({ value }) => this.setState({ customTag: value })}
                    blurOnClear
                />
                <Input
                    label={i18n.t('dashboard.pinnedFilter.label')}
                    name="pinnedFilterLabel"
                    placeholder="Filter label..."
                    onBlur={({ value }) => this.setState({ filterLabel: value })}
                    defaultValue={filterLabel}
                />
                <Select
                    label={i18n.t('dashboard.pinnedFilter.filterType')}
                    name="filterType"
                    options={filterTypes}
                    value={filterTypes.find((f) => f.value === filterType)}
                    onBlur={({ value }) => this.setState({ filterType: value })}
                    blurOnClear
                />
            </div>

        )
    }

    render() {
        const { dashStore } = this.props
        const { showAddPinnedCustomTagFilter, toggleShowAddPinnedCustomTagFilters } = dashStore
        const {
            customTag,
            filterLabel,
        } = this.state
        const canSave = customTag && filterLabel

        return (
            <Modal
                show={showAddPinnedCustomTagFilter}
                onClose={toggleShowAddPinnedCustomTagFilters}
                cssClass="createTemplateModal"
            >
                <ModalHeader>
                    <div className="title">
                        <h3>{i18n.t('report.filter.add')}</h3>
                        <h4>{i18n.t('dashboard.pinnedGroupFilter.subTitle')}</h4>
                    </div>
                </ModalHeader>
                <div className="body">
                    <div style={{ marginBottom: '10px' }}>
                        {this.renderControls()}
                    </div>
                </div>
                <ModalFooter>
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '20px' }}>
                        <Button
                            label={(
                                <div>
                                    {i18n.t('cancel')}
                                </div>
                            )}
                            cssClass="tertiary regular"
                            onClick={toggleShowAddPinnedCustomTagFilters}
                        />
                        <Button
                            label={(
                                <div>
                                    {i18n.t('save')}
                                </div>
                            )}
                            cssClass="primary regular"
                            style={{ width: '200px', fontWeight: 600, textAlign: 'center' }}
                            onClick={this.save}
                            disabled={!canSave}
                        />
                    </div>
                </ModalFooter>
            </Modal>
        )
    }
}

export default AddPinnedCustomTagFilterModal
